import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import AdminLeftMenu from "./AdminLeftMenu";
import { useTranslation } from "react-i18next";
import AdminCheck from "./AdminCheck";
import Stack from "@mui/material/Stack";
import { collection, query, getDocs, db } from "../../firebase";
import { orderBy } from "firebase/firestore";
import "react-quill/dist/quill.snow.css";
import MessageBoardTable from "./MessageBoardTable";
import Pagination from "@mui/material/Pagination";
import { HashLink } from "react-router-hash-link";

const Board = () => {
  const { t, i18n } = useTranslation();
  const numOfMessage = 10;
  const [boards, setBoards] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const handleChange = (event, value) => {
    setCurrentPage(value);
  };

  useEffect(() => {
    setBoards([]);
    window.scrollTo(0, 0);
    getBoards();
  }, []);

  const getBoards = async () => {
    setBoards([]);
    const q = query(collection(db, "board"), orderBy("created", "desc"));

    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
      // console.log("doc", doc.id, " => ", doc.data());
      setBoards((old) => old.concat({ ...doc.data(), id: doc.id }));
      //       setReviewsUS((old) => old.concat({ ...doc.data(), id: doc.id }));
    });
  };

  return (
    <Grid container>
      <AdminCheck />
      <AdminLeftMenu />
      <Grid item md={9} sm={12}>
        <Grid container>
          <Grid
            item
            md={12}
            sm={12}
            xs={12}
            sx={{ backgroundColor: "#faf9f6", minHeight: "100%", pb: 10 }}
          >
            <Box sx={{ py: 6, px: 3 }}>
              <Box sx={{ display: "flex" }} justifyContent={"space-between"}>
                <Box sx={{ fontSize: "16px" }}>한국 쇼핑몰 공지사항</Box>
              </Box>

              <Grid container spacing={2}>
                <Grid item md={12} sm={12} xs={12}>
                  <Box
                    sx={{
                      border: "1px solid lightgray",
                      my: 5,
                      backgroundColor: "white",
                      minHeight: "500px",
                    }}
                  >
                    <Box
                      sx={{
                        borderBottom: "1px solid lightgray",
                        py: 2,
                        px: 4,
                        fontWeight: "bold",
                        fontSize: "19px",
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "15px",
                      }}
                    >
                      <Box>공지사항</Box>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        px: 4,
                        py: 3,

                        pt: 2,
                      }}
                    >
                      {" "}
                      <MessageBoardTable
                        getBoards={getBoards}
                        boards={boards.slice(
                          (currentPage - 1) * numOfMessage,
                          numOfMessage * currentPage
                        )}
                      />
                      <Stack
                        spacing={2}
                        sx={{
                          pt: 5,
                        }}
                      >
                        <Pagination
                          count={Math.ceil(boards.length / numOfMessage)}
                          variant="outlined"
                          color="secondary"
                          page={currentPage}
                          onChange={handleChange}
                          sx={{ marginLeft: "auto", marginRight: "auto" }}
                        />
                      </Stack>
                      <Box sx={{ mt: 3 }}>
                        <HashLink to="/admin/board_add" smooth>
                          <button
                            className="custom_btn"
                            style={{ width: "200px" }}
                          >
                            글 추가하기
                          </button>
                        </HashLink>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Board;
// users
